<template>
  <TarjetaDatos titulo="Mascota">
    <Campo2L :valor="poliza.especie" etiqueta="Especie" />
    <Campo2L :valor="poliza.raza" etiqueta="Raza" />
    <Campo2L :valor="poliza.nombre" etiqueta="Nombre" />
    <Campo2L :valor="poliza.fecNacimiento | dateDDMMYYYY" etiqueta="F.Nacimiento" />
    <Campo2L :valor="poliza.sexo" etiqueta="Sexo" />
    <Campo2L :valor="poliza.chip" etiqueta="Chip" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
